import { render, staticRenderFns } from "./RangeShortcuts.vue?vue&type=template&id=48f9f155&scoped=true&"
import script from "./RangeShortcuts.vue?vue&type=script&lang=js&"
export * from "./RangeShortcuts.vue?vue&type=script&lang=js&"
import style0 from "./RangeShortcuts.vue?vue&type=style&index=0&id=48f9f155&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f9f155",
  null
  
)

component.options.__file = "RangeShortcuts.vue"
export default component.exports